module.exports = __webpack_public_path__ + "img/peter.d97944a7.jpg";